import React from 'react'

import EditPostContainer, {
  CommonContainerProps
} from 'containers/EditPostContainer'
import {
  CheckboxContainer,
  CertificatesContainer
} from './CandidateRequirements.style'
import { Requirement, Requirements } from '.'
import LabeledCheckbox from 'components/LabeledCheckbox'
import LighterText from 'components/Text/Lighter'
import { TextRadioForm } from 'components/RadioForm'
import ErrorText from 'components/Text/ErrorText'

interface SelectionType {
  requirement: Requirement
  isOrtho?: boolean
  isRestorative?: boolean
}

interface CandidateRequirementProps
  extends CommonContainerProps<SelectionType> {
  initRequirement?: Requirement
  isOrtho?: boolean
  isRestorative?: boolean
  displayCertificates?: boolean
}

export default class CandidateRequirements extends React.Component<
  CandidateRequirementProps
> {
  state: {
    selectedRequirement: Requirement
    isOrtho: boolean
    isRestorative: boolean
  } = {
    selectedRequirement: this.props.initRequirement as Requirement,
    isOrtho: this.props.isOrtho || false,
    isRestorative: this.props.isRestorative || false
  }

  setRequirement(requirement: Requirement) {
    this.setState({ selectedRequirement: requirement })
  }

  setOrtho(isOrtho: boolean) {
    this.setState({ isOrtho: isOrtho })
  }

  setRestorative(isRestorative: boolean) {
    this.setState({ isRestorative: isRestorative })
  }

  render() {
    return (
      <EditPostContainer
        title='Candidate Requirements'
        progressValue={62}
        {...this.props}
        onNext={() => {
          return this.props.onNext({
            requirement: this.state.selectedRequirement,
            isOrtho: this.state.isOrtho,
            isRestorative: this.state.isRestorative
          })
        }}
        isNextAvailable={!!this.state.selectedRequirement}
      >
        <LighterText>Minimum Experience Required</LighterText>
        {!this.state.selectedRequirement && (
          <ErrorText>You must select requirment to continue</ErrorText>
        )}
        <TextRadioForm
          onSelected={selected => this.setRequirement(selected)}
          items={Requirements}
          selected={this.state.selectedRequirement}
        />
        {this.props.displayCertificates && (
          <CertificatesContainer>
            <LighterText>Required Certifications</LighterText>
            <CheckboxContainer>
              <LabeledCheckbox
                checked={this.state.isOrtho}
                onSetChecked={isOrtho => this.setOrtho(isOrtho)}
              >
                <p>Orthodontic</p>
              </LabeledCheckbox>
              <br/>
              <LabeledCheckbox
                checked={this.state.isRestorative}
                onSetChecked={isRestorative =>
                  this.setRestorative(isRestorative)
                }
              >
                <p>Restorative</p>
              </LabeledCheckbox>
            </CheckboxContainer>
          </CertificatesContainer>
        )}
      </EditPostContainer>
    )
  }
}
